import { PUBLIC_URL } from "./constants";
export const MAIL_DEFAULT_SUBJECT = "New Message";
export const IFRAME_HEAD: string = `
    <base target="_blank"/>
    <link rel="stylesheet" type="text/css" href="${PUBLIC_URL}/common/message-styles.css">
`;
// Icons in string format for Tiny Editor custom buttons:
export const IconSvgData = {
  paperclip_svg: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"-2 -3 28 28\" fill=\"none\" stroke=\"#222f3e\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-paperclip\"><path d=\"M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48\"></path></svg>",
  save_svg: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#222f3e\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-save\"><path d=\"M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z\"></path><polyline points=\"17 21 17 13 7 13 7 21\"></polyline><polyline points=\"7 3 7 8 15 8\"></polyline></svg>"
};


export const FileTemplates = { //
  pdf_generator: "/templates/Account-Recovery-File-v2-Template.pdf",
  account_recovery: "/templates/Express-Account-Recovery-File-Template.pdf",
  multiple_users: "/templates/PreVeil-User-Upload-Template.csv",
  email_relay_users: "/templates/PreVeil-Email-Relay-Upload-Template.csv",
  email_group_users: "/templates/PreVeil-Group-Email-Upload-Template.csv",
  trusted_community_users: "/templates/PreVeil-Trusted-Community-Upload-Template.csv",
};
